import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../../tools/header.service';
import { StorageService } from '../../tools/storage.service';
import { IxellAPIService, IPlanningInterventionLightV1, ICreneauxPlanning, IColorUserV1, IPlanningRdvV1, ICtcV1, IIColorUserV1 } from '../../tools/api.service';
import { Language } from '../../entities/Language';
import { Country } from '../../entities/Constants';
import { Utils } from '../../tools/utils';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ColorUser } from '../../models/coloruser';
import { Router } from '@angular/router';
import { ErrorService } from '../../tools/error.service';

@Component({
    selector: 'app-planning',
    templateUrl: './planning.component.html',
    styleUrls: ['./planning.component.scss']
})

export class PlanningComponent implements OnInit {

    private langue: Language = null;
    private langueSub: any;
    languagePlanning: string;

    ctcPhone: string;
    isLoadingCreneaux: boolean = false;
    creneauxList: ICreneauxPlanning[] = [];
    isCreneauxS0: number = 1;
    isCreneaux: boolean = false;
    isCreneauDispo: boolean;

    isLoadingInterventions: boolean = false;
    isInterventions: boolean;
    interventions: IPlanningInterventionLightV1[] = [];
    interventionSelected: IPlanningInterventionLightV1;
    interventionDuration: number;

    interventionSub: any;
    ctcSub: any;
    updateCtcSub: any;
    creneauxSub: any;
    weekDatesSub: any;
    searchClientSub: any;
    verifyAvailabilitySub: any;
    registerRDVSub: any;

    dataInfo: any[] = [];
    week: number = 0;
    startDate: any;
    startDateMin: any;
    endDate: any;
    monday: Date;
    friday: Date;
    listDaysWeek: string[];
    listDaysWeekShort: string[];
    listMonday: ICreneauxPlanning[] = [];
    listTuesday: ICreneauxPlanning[] = [];
    listWednesday: ICreneauxPlanning[] = [];
    listThursday: ICreneauxPlanning[] = [];
    listFriday: ICreneauxPlanning[] = [];
    day: Date;
    isBack: boolean = false;
    isNext: boolean = false;

    RdvSelected: ICreneauxPlanning = new ICreneauxPlanning;
    heureDebutToDisplay: Date;
    heureFinToDisplay: Date;
    RdvRegistered: IPlanningRdvV1;

    country: string;
    countries: Country[] = [];

    isPhoneError: boolean = false;
    isPhoneRegistered: boolean = false;
    clientsList: IColorUserV1[] = [];
    isClients: boolean = false;
    noResults: boolean = false;
    clientSelected: IColorUserV1;

    public noWhitespaceValidator(control: UntypedFormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }

    interventionForm = new UntypedFormGroup({
        intervention: new UntypedFormControl('')
    });
    ctcPhoneForm = new UntypedFormGroup({
        ctcPhone: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator])
    });
    searchClientForm = new UntypedFormGroup({
        country: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required])
    });
    infosClientForm = new UntypedFormGroup({
        client: new UntypedFormControl('', [Validators.required])
    });

    constructor(private headerService: HeaderService, private storage: StorageService, private api: IxellAPIService, private router: Router, private errorService: ErrorService) { }

    ngOnInit() {
        this.headerService.changeTitle("support.supportAssistance");
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);
        this.countries = Utils.countries();
        this.country = this.storage.get("country");
        if (this.country) {
            this.searchClientForm.setValue({
                country: this.country,
                postalCode: ""
            });
        }

        this.langueSub = this.headerService.currentLangue.subscribe(langue => {
            let oldLangue = (this.langue != null) ? this.langue.toString() : null;
            this.langue = langue;
            this.languagePlanning = (this.langue.toString() == "tr" || this.langue.toString() == "pl") ? "en" : this.langue.toString();
            if (this.storage.get("actualLanguage") != null && oldLangue != null && oldLangue != this.storage.get("actualLanguage")) {
                this.interventionForm.reset();
                this.getInterventions();
                this.isCreneaux = false;
            }
            //if (this.langueSub != null) this.langueSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.langueSub != null) this.langueSub.unsubscribe();
        });

        // Récupération de la liste des types d'intervention
        window.setTimeout(() => {
            this.getInterventions();
        }, 1000);
    }

    getInterventions() {
        this.isLoadingInterventions = true;
        document.getElementById("btnHisto").setAttribute("disabled", "disabled");
        this.isInterventions = false;
        this.interventionSub = this.api.getInterventionList(this.langue.toString()).subscribe(data => {
            if (data) {
                this.interventions = data;
                window.setTimeout(() => {
                    this.isLoadingInterventions = false;
                    this.isInterventions = true;
                }, 1000);
            }
            window.setTimeout(() => {
                document.getElementById("btnHisto").removeAttribute("disabled");
            }, 1000);
            if (this.interventionSub != null) this.interventionSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.interventionSub != null) this.interventionSub.unsubscribe();
        })
    }

    // Sélection du type d'intervention
    selectIntervention(event: number) {
        this.interventionSelected = this.interventions.find(i => i.interventionID == event);
        this.interventionDuration = this.interventionSelected.duration;
        this.week = 0;
        this.isCreneauxS0 = 0;
        this.getCreneaux();
    }

    // Affichage du planning
    getCreneaux() {
        this.isLoadingCreneaux = true;
        this.isCreneaux = false;
        this.weekDatesSub = this.api.getWeekDates(this.week, this.languagePlanning, this.langue.toString()).subscribe(data => {

            console.log(data);

            this.startDate = data.startDate;
            this.startDateMin = data.minStartDate;
            this.endDate = data.endDate;
            this.monday = data.monday;
            this.friday = data.friday;
            this.isNext = data.isNext;
            this.listDaysWeek = data.listOfDaysWeek;
            this.listDaysWeekShort = data.listOfDaysWeekShort;
            // si aucun créneau sur la 1ère semaine, on n'affichage pas le bouton Précédent
            if (this.week == 1 && this.isCreneauxS0 == -1) {
                this.isBack = false;
            }
            else {
                this.isBack = data.isBack;
            }

            if (this.weekDatesSub != null) this.weekDatesSub.unsubscribe();

            // Récupération des créneaux
            this.creneauxSub = this.api.getCreneauxWebPlanning(this.interventionDuration, this.languagePlanning, this.startDate, this.endDate, this.startDateMin).subscribe(data2 => {

                console.log(data2);

                if (data2) {
                    this.creneauxList = data2;
                    this.listMonday = [];
                    this.listTuesday = [];
                    this.listWednesday = [];
                    this.listThursday = [];
                    this.listFriday = [];
                    this.creneauxList.forEach(element => {

                        //element.date = new Date(element.date.setHours(element.date.getHours() - 2));

                        var day = element.date.getDay();
                        switch (day) {
                            case 1:
                                this.listMonday.push(element);
                                break;
                            case 2:
                                this.listTuesday.push(element);
                                break;
                            case 3:
                                this.listWednesday.push(element);
                                break;
                            case 4:
                                this.listThursday.push(element);
                                break;
                            case 5:
                                this.listFriday.push(element);
                                break;
                        }
                    })
                    this.listMonday.sort((a, b) => { return compare(a.heureDebutRdv, b.heureDebutRdv, true); })
                    this.listTuesday.sort((a, b) => { return compare(a.heureDebutRdv, b.heureDebutRdv, true); })
                    this.listWednesday.sort((a, b) => { return compare(a.heureDebutRdv, b.heureDebutRdv, true); })
                    this.listThursday.sort((a, b) => { return compare(a.heureDebutRdv, b.heureDebutRdv, true); })
                    this.listFriday.sort((a, b) => { return compare(a.heureDebutRdv, b.heureDebutRdv, true); })

                    console.log("this.listMonday");
                    console.log(this.listMonday);
                    console.log("this.listTuesday");
                    console.log(this.listTuesday);
                    console.log("this.listWednesday");
                    console.log(this.listWednesday);
                    console.log("this.listThursday");
                    console.log(this.listThursday);
                    console.log("this.listFriday");
                    console.log(this.listFriday);


                    if (this.week == 0) {
                        this.isCreneauxS0 = this.creneauxList.findIndex(p => p.reserved == 1);
                        if (this.isCreneauxS0 != -1) {
                            this.isCreneaux = true;
                            this.isLoadingCreneaux = false;
                        }
                        // si aucun créneau sur la 1ère semaine, chargement de la semaine suivante
                        else {
                            this.isCreneaux = false;
                            this.isLoadingCreneaux = true;
                            this.next();
                        }
                    }
                    else {
                        this.isCreneaux = true;
                        this.isLoadingCreneaux = false;
                    }

                }
                else {
                    this.isCreneaux = false;
                    this.isLoadingCreneaux = false;
                }
                if (this.creneauxSub != null) this.creneauxSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getCreneauxWebPlanning", new Date().toString());
                    if (this.creneauxSub != null) this.creneauxSub.unsubscribe();
                })
        },
            error => {
                console.log(error);
                this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getWeekDates", new Date().toString());
                if (this.weekDatesSub != null) this.weekDatesSub.unsubscribe();
            });

    }

    back() {
        this.week -= 1;
        this.getCreneaux();
    }

    next() {
        this.week += 1;
        this.getCreneaux();
    }

    selectRDV(rdv: ICreneauxPlanning) {
        this.getCtcPhone();
        this.RdvSelected = rdv;
        this.heureDebutToDisplay = this.RdvSelected.date;
        this.heureFinToDisplay = new Date(this.RdvSelected.date.getTime() + this.interventionDuration * 60000);
        this.openModal('infosClientModal');
    }

    getCtcPhone() {
        this.ctcSub = this.api.getCtcInfos().subscribe(data => {
            if (data.phone) {
                if (data.phone.toLowerCase() != "null") {
                    this.ctcPhone = data.phone;
                    this.ctcPhoneForm.controls["ctcPhone"].setValue(this.ctcPhone);
                }
            }
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        }, error => {
            console.log(error);
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getCtcInfos", new Date().toString());
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        })
    }

    savePhone() {
        if (!Utils.IsNullOrWhiteSpace(this.ctcPhoneForm.value["ctcPhone"])) {
            this.isPhoneError = false;
            var ctcPhoneNew = this.ctcPhoneForm.value["ctcPhone"].trim();
            if (ctcPhoneNew != this.ctcPhone) {
                this.ctcPhone = ctcPhoneNew;
                this.updateCtcSub = this.api.updateCtcPhone(this.ctcPhone).subscribe(data => {
                    if (data) {
                        this.isPhoneRegistered = true;
                    }
                    if (this.updateCtcSub != null) this.updateCtcSub.unsubscribe();
                }, error => {
                    console.log(error);
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "updateCtc", new Date().toString());
                    if (this.updateCtcSub != null) this.updateCtcSub.unsubscribe();
                })
            }
        }
        else {
            this.isPhoneError = true;
            this.isPhoneRegistered = false;
        }
    }

    searchClient() {
        let postalCode = this.searchClientForm.value.postalCode;
        //let pays = this.searchClientForm.value.country;
        let pays = this.country;
        let country = pays;
        switch (pays.toLowerCase()) {
            case "germany": country = "Deutschland"; break;
            case "united kingdom": country = "United Kingdom"; break;
            //case "spain": country = "España"; break;
            case "spain": country = "Spain"; break;
            case "france": country = "France"; break;
            case "belgium": country = "Belgique"; break;
            case "italy": country = "Italia"; break;
            case "luxembourg": country = "Luxembourg"; break;
            case "netherlands": country = "Netherlands"; break;
            case "romania": country = "Romania"; break;
            case "poland": country = "Polska"; break;
            case "portugal": country = "Portugal"; break;
            case "turkey": country = "TÜRKİYE"; break;
        }
        if (!Utils.IsNullOrWhiteSpace(postalCode)) {
            this.searchClientSub = this.api.getClientsByCountryAndPostalCodePlanning(country, postalCode).subscribe(data => {
                if (data) {
                    this.clientsList = data;
                    if (this.clientsList.length > 0) {
                        this.isClients = true;
                        this.noResults = false;
                        this.infosClientForm.setValue({
                            client: this.clientsList[0]
                        });
                        this.clientSelected = this.clientsList[0];
                    }
                    else {
                        this.isClients = false;
                        this.noResults = true;
                    }
                }
            }, error => {
                console.log(error);
                this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "getClientsByCountryAndPostalCodePlanning", new Date().toString());
                if (this.searchClientSub != null) this.searchClientSub.unsubscribe();
            });
        }
    }

    changeValueClient(client: IColorUserV1) {
        this.clientSelected = client;
    }

    resetClients(event: KeyboardEvent) {
        if (event.key !== 'Return')
            this.isClients = false;
    }

    //verifCreneau() {
    //    this.isCreneauDispo = false;
    //    this.verifyAvailabilitySub = this.api.verifyRDVAvailable(this.RdvSelected, this.interventionDuration, this.languagePlanning, this.startDate, this.endDate, this.startDateMin, this.RdvSelected.planningToken, this.RdvSelected.dateString, this.RdvSelected.heureDebutRdv, this.RdvSelected.heureFinRdv).subscribe(data => {
    //        if (data) {
    //            this.isCreneauDispo = true;
    //            this.RdvSelected = data;
    //        }
    //        else {
    //            this.isCreneauDispo = false;
    //        }
    //    }, error => {
    //        console.log(error);
    //        this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "verifyRDVAvailable", new Date().toString());
    //        if (this.creneauxSub != null) this.creneauxSub.unsubscribe();
    //    })
    //}

    selectClient() {
        var client = this.infosClientForm.value.client;
        this.clientSelected = client;
        this.ctcPhoneForm.markAllAsTouched();
        if (!Utils.IsNullOrWhiteSpace(this.ctcPhoneForm.value.ctcPhone)) {
            if (client != null) {
                this.closeModal("infosClientModal");
                this.openModal("loadingModal");
                //this.verifCreneau();

                this.isCreneauDispo = false;
                this.verifyAvailabilitySub = this.api.verifyRDVAvailable(this.RdvSelected, this.interventionDuration, this.languagePlanning, this.startDate, this.endDate, this.startDateMin, this.RdvSelected.planningToken).subscribe(data => {

                    console.log(data);

                    if (data) {
                        this.isCreneauDispo = true;
                        this.RdvSelected = data;
                        this.insertRdv();

                        ///* TMP */this.closeModal("loadingModal");
                    }
                    else {
                        this.isCreneauDispo = false;
                        this.closeModal("loadingModal");
                        this.openModal("unavailableModal");
                    }
                }, error => {
                    console.log(error);
                    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "verifyRDVAvailable", new Date().toString());
                    if (this.creneauxSub != null) this.creneauxSub.unsubscribe();
                });

                //window.setTimeout(() => {
                //    if (this.isCreneauDispo) {
                //        this.insertRdv();
                //    }
                //    else {
                //        this.closeModal("loadingModal");
                //        this.openModal("unavailableModal");
                //    }
                //}, 2000);
            }
        }
    }

    insertRdv() {
        var endDate = new Date(this.RdvSelected.date.getTime() + this.interventionDuration * 60000);

        this.RdvRegistered = new IPlanningRdvV1();
        this.RdvRegistered.wpPlanningID = this.RdvSelected.planningID;
        this.RdvRegistered.planningToken = this.RdvSelected.planningToken;
        this.RdvRegistered.interventionID = this.interventionSelected.interventionID;
        this.RdvRegistered.startDate = new Date(this.RdvSelected.date.getTime());
        this.RdvRegistered.endDate = endDate;
        this.RdvRegistered.coloruser_UserID = this.clientSelected.idcolorUser;

        this.registerRDVSub = this.api.registerRDV(this.RdvRegistered).subscribe(data => {
            if (data) {
                this.closeModal("loadingModal");
                this.openModal("confirmationModal");
            }
            else {
                this.closeModal("loadingModal");
                this.openModal("errorModal");
            }
        }, error => {
            console.log(error);
            this.closeModal("loadingModal");
            this.openModal("errorModal");
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "registerRDV", new Date().toString());
            if (this.registerRDVSub != null) this.registerRDVSub.unsubscribe();
        })
    }

    closeError() {
        this.closeModal("errorModal");
        this.getCreneaux();
    }

    closeModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
        switch (name) {
            case 'infosClientModal':
                //this.searchClientForm.reset();
                //this.isClients = false;
                //this.infosClientForm.reset();
                break;
            case 'unavailableModal':
                this.getCreneaux();
                break;
            case 'confirmationModal':
                this.router.navigate(['/planningHistorique']);
                break;
        }
    }

    openModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "block";
    }

    ngOnDestroy() {
        if (this.interventionSub != null) this.interventionSub.unsubscribe();
        if (this.weekDatesSub != null) this.weekDatesSub.unsubscribe();
        if (this.creneauxSub != null) this.creneauxSub.unsubscribe();
        if (this.searchClientSub != null) this.searchClientSub.unsubscribe();
        if (this.verifyAvailabilitySub != null) this.verifyAvailabilitySub.unsubscribe();
        if (this.registerRDVSub != null) this.registerRDVSub.unsubscribe();
        if (this.ctcSub != null) this.ctcSub.unsubscribe();
        if (this.updateCtcSub != null) this.updateCtcSub.unsubscribe();
        if (this.langueSub != null) this.langueSub.unsubscribe();
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a == null) return -1;
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
